import { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useSmartApps } from "./SmartApp";
import { Avatar, Divider, Grid, useTheme, Box, Typography } from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";

export interface ISmartAppStep {
  step: number;
  titleKey: string;
  descriptionKey: string;
  children?: any;
  visible?: boolean;
}

export default observer(function SmartAppStep(props: ISmartAppStep) {
  const {palette} = useTheme();
  const { titleKey, descriptionKey, visible, children } = props;
  const { step } = useSmartApps();

  const done = useMemo(() => step >= props.step, [props.step, step]);

  return (
    <Grid container>
      <Grid item xs={3} sx={{display: "flex", flexDirection: "column", alignItems: "start", mt: 2}}>
        <Box display="flex" flexDirection="row">
          <Avatar sx={{backgroundColor: done ? palette.primary.main : ""}}>{props.step}</Avatar>
          <Typography variant="h6" color={done ? palette.primary.main : "GrayText"} sx={{ml: 2, fontWeight: "bold"}}>{translationService.translate(titleKey)}</Typography>
        </Box>
        <Divider sx={{m: 2, borderLeftWidth: 1}} orientation="vertical"/>
      </Grid>
      {visible && <Grid container rowSpacing={1} xs={9} sx={{mt: 2}}>
        {children}
      </Grid>}
    </Grid>
  );
});
